"use client";

import { useState } from "react";
import { Pencil } from "lucide-react";
import "../Css/PreviewMainForm.css";
import { useDispatch } from "react-redux";
import { setActiveTabIndex } from "../actions";
import {
  server_post_data,
  repairing_car_data,
} from "../../ServiceConnection/serviceconnection";
import { handleError, handleSuccess } from "../../CommonJquery/CommonJquery";
import { useNavigate } from "react-router-dom";

const PreviewRepairForm = ({
  onBack,
  MaintainanceData,
  cardata,
  ImageLink,
  FromComeData,
}) => {
  const dispatch = useDispatch();
  const [showLoaderAdmin, setShowLoaderAdmin] = useState(false);
  const navigate = useNavigate();
  //console.log("MaintainanceData", MaintainanceData);

  const handleEdit = (section) => {
    switch (section) {
      case "odometerVehicleImages":
        dispatch(setActiveTabIndex(1));
        break;
      case "damageAdditionalNotes":
        dispatch(setActiveTabIndex(2));
        break;
      default:
        //console.log("Invalid section");
    }
  };

  const handleclickSubmit = async () => {
    setShowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("car_id", cardata.primary_id);
    fd.append("step_for_repairing", 3);
    fd.append("edit_or_new", MaintainanceData?.primary_id || 0);
    fd.append("save_or_edit_type", FromComeData);

    await server_post_data(repairing_car_data, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          handleSuccess(Response.data.message);
          navigate("/Maintanance");
        }
        setShowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setShowLoaderAdmin(false);
      });
  };
  const labels = ["Front Left", "Front Right", "Back Left", "Back Right"];
  // Odometer & Vehicle Images Section
  const OdometerVehicleImagesSection = () => {
    return (
      <div className="check-section mb-4">
        <div className="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 className="section-title">Odometer & Vehicle Images</h3>
          <button
            className="edit-button btn btn-sm"
            onClick={() => handleEdit("odometerVehicleImages")}
          >
            <Pencil className="icon-pencil" />
          </button>
        </div>
        <div className="section-content card">
          <div className="card-body">
            <h4 className="border-bottom py-2">Odometer Information</h4>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Odometer Reading
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.odo_metter || "N/A"}
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Picture of Odometer
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.odo_image && (
                    <img
                      src={
                        ImageLink + MaintainanceData.odo_image ||
                        "/placeholder.svg"
                      }
                      onError={(e) => {
                        e.target.style.display = "none";
                      }}
                      className="step_8_img_view"
                      alt="Odometer"
                    />
                  )}
                </span>
              </div>
            </div>

            <h4 className="border-bottom py-2 mt-3">Vehicle Corner Images</h4>

            {MaintainanceData.corner_image
              ?.split("@@@")
              .filter((item) => item !== "" && item !== "0")
              .map((imageName, index) => (
                <div className="field-row row border-bottom py-2" key={index}>
                  <label className="field-label col-sm-7 col-md-8">
                    {labels[index] || `Corner ${index + 1}`}
                  </label>
                  <div className="field-value-container col-sm-5 col-md-4 text-end">
                    <span className="field-value">
                      <img
                        src={ImageLink + imageName}
                        onError={(e) => {
                          e.target.style.display = "none";
                        }}
                        alt={`Repair ${index + 1}`}
                        className="img-fluid step_8_img_view"
                      />
                    </span>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    );
  };

  // Damage & Additional Notes Section
  const DamageAdditionalNotesSection = () => {
    return (
      <div className="check-section mb-4">
        <div className="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 className="section-title">Damage & Additional Notes</h3>
          <button
            className="edit-button btn btn-sm"
            onClick={() => handleEdit("damageAdditionalNotes")}
          >
            <Pencil className="icon-pencil" />
          </button>
        </div>
        <div className="section-content card">
          <div className="card-body">
            <h4 className="border-bottom py-2">Damage Information</h4>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Damage Pictures
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <div className="row">
                  {MaintainanceData.corner_image
                    ?.split("@@@")
                    .filter((item) => item !== "" && item !== "0")
                    .map((imageName, index) => (
                      <div className="col-3" key={index}>
                        <img
                          src={ImageLink + imageName}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                          alt={`Damage ${index}`}
                          className="img-fluid step_8_img_view"
                        />
                      </div>
                    ))}
                </div>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Damage Charges
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  ${MaintainanceData.damage_amount_box || "0.00"}
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Damage Details
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.notes_for_future || "N/A"}
                </span>
              </div>
            </div>

            <h4 className="border-bottom py-2 mt-3">Additional Information</h4>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Additional Notes
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {MaintainanceData.additional_notes || "N/A"}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="final-checks-container">
      <div className="form-header mb-4">
        <h2 className="form-title mb-2">Final Repair Inspection Checklist</h2>
        <p className="form-subtitle text-muted">
          Verify all repair inspections have been completed before submitting
        </p>
      </div>

      {OdometerVehicleImagesSection()}
      {DamageAdditionalNotesSection()}

      <div className="navigation-buttons">
        <button className="btn back-button" onClick={onBack}>
          Back
        </button>
        <button
          className="btn next__button"
          onClick={handleclickSubmit}
          disabled={showLoaderAdmin}
        >
          {showLoaderAdmin ? "Submitting..." : "Submit"}
        </button>
      </div>
    </div>
  );
};

export default PreviewRepairForm;
